import React, { useState } from "react";
import "./CreateAccordian.css";
import * as BsXLg from "react-icons/bs";
import { Link } from 'react-router-dom';
import { Accordion } from 'react-bootstrap'
import pic21 from "../../img/pic21.jpg";
import pic22 from "../../img/pic22.jpg";
import pic23 from "../../img/pic23.jpg";
import pic24 from "../../img/pic24.jpg";
import pic25 from "../../img/pic25.jpg";
import pic26 from "../../img/pic26.jpg";
import pic27 from "../../img/pic27.jpg";
import pic28 from "../../img/pic28.jpg";
import pic29 from "../../img/pic29.jpg";
import pic30 from "../../img/pic30.jpg";
import pic31 from "../../img/pic31.png";
import * as BiBookContent from 'react-icons/bi';
import * as IoIosArrowBack from "react-icons/io";

import Form from 'react-bootstrap/Form';
import CreateAccordianlink from "./CreateAccordianlink";



function Accordian({ setCreatbtn }) {
    const [page, setPage] = useState(0)



    console.log("pages ;", page)

    return (
        <div>


            <Accordion defaultActiveKey="0" className="divbackrounddives">
                <Accordion.Item eventKey="0" style={{ marginTop: "110px" }}>
                    <div className='acuntdives'>
                        <div className="icondiviconseswww">
                            {page != 0 &&
                                <IoIosArrowBack.IoIosArrowBack style={{ cursor: 'pointer' }} onClick={() => setPage(0)} />} </div>

                        <span className="adngtmpltdiv" >Templates </span>



                        <Link className="iconcolorchngeses" >
                            <BsXLg.BsXLg onClick={() => setCreatbtn(false)} />
                        </Link>
                    </div>

                    <hr style={{ width: "260px", border: '0.5px solid darkgray' }} />
                    {page == 0 &&
                        <>

                            <Accordion.Header className="divtempltsizes">Templates</Accordion.Header>
                            <Accordion.Body >
                                <div className="divimg-paraes">
                                    <img src={pic21} className='imagesdivcntres'></img>
                                    <p className="paradivcntres" style={{ cursor: "pointer" }} onClick={() => setPage(1)}>1-on-1 meeting agenda  </p>
                                </div>
                                <div className="divimg-paraes">
                                    <img src={pic22} className='imagesdivcntres' ></img>
                                    <p className="paradivcntres" style={{ cursor: "pointer" }} onClick={() => setPage(2)}>Agile Board Template |Trello</p>
                                </div>
                                <div className="divimg-paraes">
                                    <img src={pic23} className='imagesdivcntres'></img>
                                    <p className="paradivcntres" style={{ cursor: "pointer" }} onClick={() => setPage(3)}>Company Overview</p>
                                </div>
                                <div className="divimg-paraes">
                                    <img src={pic24} className='imagesdivcntres'></img>
                                    <p className="paradivcntres" style={{ cursor: "pointer" }} onClick={() => setPage(4)}>Design huddle</p>
                                </div>
                                <div className="divimg-paraes">
                                    <img src={pic25} className='imagesdivcntres'></img>
                                    <p className="paradivcntres" style={{ cursor: "pointer" }} onClick={() => setPage(5)}>Go To MArket Strategy Template</p>
                                </div>
                                <div className="divimg-paraes">
                                    <img src={pic26} className='imagesdivcntres'></img>
                                    <p className="paradivcntres" style={{ cursor: "pointer" }} onClick={() => setPage(6)}>Kanban Template</p>
                                </div>
                                <div className="divimg-paraes">
                                    <img src={pic27} className='imagesdivcntres'></img>
                                    <p className="paradivcntres" style={{ cursor: "pointer" }} onClick={() => setPage(7)}>Mise-En-Place Personal Product..</p>
                                </div>
                                <div className="divimg-paraes">
                                    <img src={pic28} className='imagesdivcntres'></img>
                                    <p className="paradivcntres" style={{ cursor: "pointer" }} onClick={() => setPage(8)}>Project Management</p>
                                </div>
                                <div className="divimg-paraes">
                                    <img src={pic29} className='imagesdivcntres'></img>
                                    <p className="paradivcntres" style={{ cursor: "pointer" }} onClick={() => setPage(9)}>Remote Team Meeting</p>
                                </div>
                                <div className="divimg-paraes">
                                    <img src={pic30} className='imagesdivcntres'></img>
                                    <p className="paradivcntres" style={{ cursor: "pointer" }} onClick={() => setPage(10)}>Simple Project Board</p>
                                </div>
                                <div className="divimg-paraes">
                                    <img src={pic31} className='imagesdivcntres'></img>
                                    <p className="paradivcntres" style={{ cursor: "pointer" }} onClick={() => setPage(11)}>Teaching: Weekly Planning</p>
                                </div>
                            </Accordion.Body>
                        </>
                    }



                    {
                        page == 0 && <>
                            <hr style={{ width: "290px", border: '1px solid darkgray', marginTop: "0.5rem" }} />
                            <div className="diviconschnges">

                                <div className="diviconslrges"> <BiBookContent.BiBookContent /></div>
                                <span className="divflexdivalles">See hundreds of templates from the Trello community</span>
                            </div>

                            <div className="divlinediesbbbb">
                                <button className="btndivbtnnones">Explore Templates</button>
                            </div>
                        </>
                    }
                    <div >
                        <p></p>
                    </div>
                </Accordion.Item>
            </Accordion>
            {page == 1 &&
                <>
                    <CreateAccordianlink />
                </>

            }

            {
                page == 2 &&
                <>
                    <div className="modalBackground">
                        <div className="modalContainerswww">



                            <div >
                                <div>
                                    <img src={pic22} className="divrightimg"></img>
                                </div>
                                <div className="divfontgmails">
                                    <span ><b>Agile Board Template|Trel..</b></span>
                                    <span >by Lyndi Thompson, Sr. Demand G...</span>
                                </div>
                            </div>

                            <div className="divanotherdivtext">
                                <span>Whether it's shipping a product
                                    or running through iterations of
                                    a project plan, this agile board template
                                    will help you get things done.</span>
                            </div>
                            <hr style={{ width: "250px", border: '1px solid darkgray', marginTop: "0.5rem" }} />

                            <label className='lablinputtext' for="myInput">Board Title</label>
                            <input id="myInput" type="text" placeholder="Agile Board Template|Trel.." />
                            <label className='lablinputtext' for="myInput">Visibilty</label>
                            <div class="Workspacess">
                                <select className='slecoptondiv'>
                                    <option value="0">Workspace</option>
                                    <option value="1">Private</option>
                                    <option value="2">WorkSpace</option>
                                    <option value="2">Public</option>

                                </select>
                            </div>
                            <div>
                                <Form className='checkbivbox'>
                                    {['checkbox'].map((type) => (
                                        <div key={`Keep-${type}`} className="mb-3">
                                            <Form.Check
                                                type={type}
                                                id={`Keep-${type}`}
                                                label={`Keep ${type}`}
                                            />


                                        </div>
                                    ))}
                                </Form>
                            </div>
                            <div className="divanotherdivtextify">
                                <span >Activity and members will not be copied to the new board.</span>
                            </div>

                            <div className='btncre2btn'>
                                <button className='btncrebtn'>Create</button>
                            </div>
                        </div>
                    </div>
                </>
            }


            {
                page == 3 &&
                <>
                    <div className="modalBackground">
                        <div className="modalContainerswww">
                            <div >
                                <div>
                                    <img src={pic23} className="divrightimg"></img>
                                </div>
                                <div className="divfontgmails">
                                    <span ><b>Company Overview</b></span>
                                    <span >by Michael Pryor, Head of Prod...</span>
                                </div>
                            </div>
                            <div className="divanotherdivtext">
                                <span>Whether it's shipping a product
                                    or running through iterations of
                                    a project plan, this agile board template
                                    will help you get things done.</span>
                            </div>
                            <hr style={{ width: "250px", border: '1px solid darkgray', marginTop: "0.5rem" }} />
                            <label className='lablinputtext' for="myInput">Board Title</label>
                            <input id="myInput" type="text" placeholder="Company Overview" />
                            <label className='lablinputtext' for="myInput">Visibilty</label>
                            <div class="Workspacess">
                                <select className='slecoptondiv'>
                                    <option value="0">Workspace</option>
                                    <option value="1">Private</option>
                                    <option value="2">WorkSpace</option>
                                    <option value="2">Public</option>
                                </select>
                            </div>
                            <div>
                                <Form className='checkbivbox'>
                                    {['checkbox'].map((type) => (
                                        <div key={`Keep-${type}`} className="mb-3">
                                            <Form.Check
                                                type={type}
                                                id={`Keep-${type}`}
                                                label={`Keep ${type}`}
                                            />
                                        </div>
                                    ))}
                                </Form>
                            </div>
                            <div className="divanotherdivtextify">
                                <span >Activity and members will not be copied to the new board.</span>
                            </div>

                            <div className='btncre2btn'>
                                <button className='btncrebtn'>Create</button>
                            </div>
                        </div>
                    </div>
                </>
            }


            {
                page == 4 &&
                <>
                    <div className="modalBackground">
                        <div className="modalContainerswww">
                            <div >
                                <div>
                                    <img src={pic24} className="divrightimg"></img>
                                </div>
                                <div className="divfontgmails">
                                    <span ><b>Design Huddle</b></span>
                                    <span >by Courtney Drake, Design Man..</span>
                                </div>
                            </div>
                            <div className="divanotherdivtext">
                                <span>Whether it's shipping a product
                                    or running through iterations of
                                    a project plan, this agile board template
                                    will help you get things done.</span>
                            </div>
                            <hr style={{ width: "250px", border: '1px solid darkgray', marginTop: "0.5rem" }} />
                            <label className='lablinputtext' for="myInput">Board Title</label>
                            <input id="myInput" type="text" placeholder="Company Overview" />
                            <label className='lablinputtext' for="myInput">Visibilty</label>
                            <div class="Workspacess">
                                <select className='slecoptondiv'>
                                    <option value="0">Workspace</option>
                                    <option value="1">Private</option>
                                    <option value="2">WorkSpace</option>
                                    <option value="2">Public</option>
                                </select>
                            </div>
                            <div>
                                <Form className='checkbivbox'>
                                    {['checkbox'].map((type) => (
                                        <div key={`Keep-${type}`} className="mb-3">
                                            <Form.Check
                                                type={type}
                                                id={`Keep-${type}`}
                                                label={`Keep ${type}`}
                                            />
                                        </div>
                                    ))}
                                </Form>
                            </div>
                            <div className="divanotherdivtextify">
                                <span >Activity and members will not be copied to the new board.</span>
                            </div>

                            <div className='btncre2btn'>
                                <button className='btncrebtn'>Create</button>
                            </div>
                        </div>
                    </div>
                </>
            }


            {
                page == 5 &&
                <>
                    <div className="modalBackground">
                        <div className="modalContainerswww">
                            <div >
                                <div>
                                    <img src={pic25} className="divrightimg"></img>
                                </div>
                                <div className="divfontgmails">
                                    <span ><b>Go To Market Strategy Template </b></span>
                                    <span >by Trello Marketing Team...</span>
                                </div>
                            </div>
                            <div className="divanotherdivtext">
                                <span>Whether it's shipping a product
                                    or running through iterations of
                                    a project plan, this agile board template
                                    will help you get things done.</span>
                            </div>
                            <hr style={{ width: "250px", border: '1px solid darkgray', marginTop: "0.5rem" }} />
                            <label className='lablinputtext' for="myInput">Board Title</label>
                            <input id="myInput" type="text" placeholder="Go To Market Strategy Template " />
                            <label className='lablinputtext' for="myInput">Visibilty</label>
                            <div class="Workspacess">
                                <select className='slecoptondiv'>
                                    <option value="0">Workspace</option>
                                    <option value="1">Private</option>
                                    <option value="2">WorkSpace</option>
                                    <option value="2">Public</option>
                                </select>
                            </div>
                            <div>
                                <Form className='checkbivbox'>
                                    {['checkbox'].map((type) => (
                                        <div key={`Keep-${type}`} className="mb-3">
                                            <Form.Check
                                                type={type}
                                                id={`Keep-${type}`}
                                                label={`Keep ${type}`}
                                            />
                                        </div>
                                    ))}
                                </Form>
                            </div>
                            <div className="divanotherdivtextify">
                                <span >Activity and members will not be copied to the new board.</span>
                            </div>

                            <div className='btncre2btn'>
                                <button className='btncrebtn'>Create</button>
                            </div>
                        </div>
                    </div>
                </>
            }

            {
                page == 6 &&
                <>
                    <div className="modalBackground">
                        <div className="modalContainerswww">
                            <div >
                                <div>
                                    <img src={pic26} className="divrightimg"></img>
                                </div>
                                <div className="divfontgmails">
                                    <span ><b>Kanban Template</b></span>
                                    <span >by Trello Engineering Team...</span>
                                </div>
                            </div>
                            <div className="divanotherdivtext">
                                <span>Whether it's shipping a product
                                    or running through iterations of
                                    a project plan, this agile board template
                                    will help you get things done.</span>
                            </div>
                            <hr style={{ width: "250px", border: '1px solid darkgray', marginTop: "0.5rem" }} />
                            <label className='lablinputtext' for="myInput">Board Title</label>
                            <input id="myInput" type="text" placeholder=" Kanban Template" />
                            <label className='lablinputtext' for="myInput">Visibilty</label>
                            <div class="Workspacess">
                                <select className='slecoptondiv'>
                                    <option value="0">Workspace</option>
                                    <option value="1">Private</option>
                                    <option value="2">WorkSpace</option>
                                    <option value="2">Public</option>
                                </select>
                            </div>
                            <div>
                                <Form className='checkbivbox'>
                                    {['checkbox'].map((type) => (
                                        <div key={`Keep-${type}`} className="mb-3">
                                            <Form.Check
                                                type={type}
                                                id={`Keep-${type}`}
                                                label={`Keep ${type}`}
                                            />
                                        </div>
                                    ))}
                                </Form>
                            </div>
                            <div className="divanotherdivtextify">
                                <span >Activity and members will not be copied to the new board.</span>
                            </div>

                            <div className='btncre2btn'>
                                <button className='btncrebtn'>Create</button>
                            </div>
                        </div>
                    </div>
                </>
            }



            {
                page == 7 &&
                <>
                    <div className="modalBackground">
                        <div className="modalContainerswww">
                            <div >
                                <div>
                                    <img src={pic27} className="divrightimg"></img>
                                </div>
                                <div className="divfontgmails">
                                    <span ><b>Mise-En-Place Personal Productivity System</b></span>
                                    <span >by Justin Gallagher, Head of Pro...</span>
                                </div>
                            </div>
                            <div className="divanotherdivtext">
                                <span>Whether it's shipping a product
                                    or running through iterations of
                                    a project plan, this agile board template
                                    will help you get things done.</span>
                            </div>
                            <hr style={{ width: "250px", border: '1px solid darkgray', marginTop: "0.5rem" }} />
                            <label className='lablinputtext' for="myInput">Board Title</label>
                            <input id="myInput" type="text" placeholder="Mise-En-Place Personal Productivity System " />
                            <label className='lablinputtext' for="myInput">Visibilty</label>
                            <div class="Workspacess">
                                <select className='slecoptondiv'>
                                    <option value="0">Workspace</option>
                                    <option value="1">Private</option>
                                    <option value="2">WorkSpace</option>
                                    <option value="2">Public</option>
                                </select>
                            </div>
                            <div>
                                <Form className='checkbivbox'>
                                    {['checkbox'].map((type) => (
                                        <div key={`Keep-${type}`} className="mb-3">
                                            <Form.Check
                                                type={type}
                                                id={`Keep-${type}`}
                                                label={`Keep ${type}`}
                                            />
                                        </div>
                                    ))}
                                </Form>
                            </div>
                            <div className="divanotherdivtextify">
                                <span >Activity and members will not be copied to the new board.</span>
                            </div>

                            <div className='btncre2btn'>
                                <button className='btncrebtn'>Create</button>
                            </div>
                        </div>
                    </div>
                </>
            }


            {
                page == 8 &&
                <>
                    <div className="modalBackground">
                        <div className="modalContainerswww">
                            <div >
                                <div>
                                    <img src={pic28} className="divrightimg"></img>
                                </div>
                                <div className="divfontgmails">
                                    <span ><b>Project Management</b></span>
                                    <span >by Trello Marketing Team...</span>
                                </div>
                            </div>
                            <div className="divanotherdivtext">
                                <span>Whether it's shipping a product
                                    or running through iterations of
                                    a project plan, this agile board template
                                    will help you get things done.</span>
                            </div>
                            <hr style={{ width: "250px", border: '1px solid darkgray', marginTop: "0.5rem" }} />
                            <label className='lablinputtext' for="myInput">Board Title</label>
                            <input id="myInput" type="text" placeholder="Project Management " />
                            <label className='lablinputtext' for="myInput">Visibilty</label>
                            <div class="Workspacess">
                                <select className='slecoptondiv'>
                                    <option value="0">Workspace</option>
                                    <option value="1">Private</option>
                                    <option value="2">WorkSpace</option>
                                    <option value="2">Public</option>
                                </select>
                            </div>
                            <div>
                                <Form className='checkbivbox'>
                                    {['checkbox'].map((type) => (
                                        <div key={`Keep-${type}`} className="mb-3">
                                            <Form.Check
                                                type={type}
                                                id={`Keep-${type}`}
                                                label={`Keep ${type}`}
                                            />
                                        </div>
                                    ))}
                                </Form>
                            </div>
                            <div className="divanotherdivtextify">
                                <span >Activity and members will not be copied to the new board.</span>
                            </div>

                            <div className='btncre2btn'>
                                <button className='btncrebtn'>Create</button>
                            </div>
                        </div>
                    </div>
                </>
            }
            {
                page == 9 &&
                <>
                    <div className="modalBackground">
                        <div className="modalContainerswww">
                            <div >
                                <div>
                                    <img src={pic29} className="divrightimg"></img>
                                </div>
                                <div className="divfontgmails">
                                    <span ><b>Remote Team Meetings</b></span>
                                    <span >by Trello Marketing Team...</span>
                                </div>
                            </div>
                            <div className="divanotherdivtext">
                                <span>Whether it's shipping a product
                                    or running through iterations of
                                    a project plan, this agile board template
                                    will help you get things done.</span>
                            </div>
                            <hr style={{ width: "250px", border: '1px solid darkgray', marginTop: "0.5rem" }} />
                            <label className='lablinputtext' for="myInput">Board Title</label>
                            <input id="myInput" type="text" placeholder="Remote Team Meetings  " />
                            <label className='lablinputtext' for="myInput">Visibilty</label>
                            <div class="Workspacess">
                                <select className='slecoptondiv'>
                                    <option value="0">Workspace</option>
                                    <option value="1">Private</option>
                                    <option value="2">WorkSpace</option>
                                    <option value="2">Public</option>
                                </select>
                            </div>
                            <div>
                                <Form className='checkbivbox'>
                                    {['checkbox'].map((type) => (
                                        <div key={`Keep-${type}`} className="mb-3">
                                            <Form.Check
                                                type={type}
                                                id={`Keep-${type}`}
                                                label={`Keep ${type}`}
                                            />
                                        </div>
                                    ))}
                                </Form>
                            </div>
                            <div className="divanotherdivtextify">
                                <span >Activity and members will not be copied to the new board.</span>
                            </div>

                            <div className='btncre2btn'>
                                <button className='btncrebtn'>Create</button>
                            </div>
                        </div>
                    </div>
                </>
            }
            {
                page == 10 &&
                <>
                    <div className="modalBackground">
                        <div className="modalContainerswww">
                            <div >
                                <div>
                                    <img src={pic30} className="divrightimg"></img>
                                </div>
                                <div className="divfontgmails">
                                    <span ><b>Simple Project Board</b></span>
                                    <span >by David Mugisha, Senior AI Tec..</span>
                                </div>
                            </div>
                            <div className="divanotherdivtext">
                                <span>Whether it's shipping a product
                                    or running through iterations of
                                    a project plan, this agile board template
                                    will help you get things done.</span>
                            </div>
                            <hr style={{ width: "250px", border: '1px solid darkgray', marginTop: "0.5rem" }} />
                            <label className='lablinputtext' for="myInput">Board Title</label>
                            <input id="myInput" type="text" placeholder="Simple Project Board  " />
                            <label className='lablinputtext' for="myInput">Visibilty</label>
                            <div class="Workspacess">
                                <select className='slecoptondiv'>
                                    <option value="0">Workspace</option>
                                    <option value="1">Private</option>
                                    <option value="2">WorkSpace</option>
                                    <option value="2">Public</option>
                                </select>
                            </div>
                            <div>
                                <Form className='checkbivbox'>
                                    {['checkbox'].map((type) => (
                                        <div key={`Keep-${type}`} className="mb-3">
                                            <Form.Check
                                                type={type}
                                                id={`Keep-${type}`}
                                                label={`Keep ${type}`}
                                            />
                                        </div>
                                    ))}
                                </Form>
                            </div>
                            <div className="divanotherdivtextify">
                                <span >Activity and members will not be copied to the new board.</span>
                            </div>

                            <div className='btncre2btn'>
                                <button className='btncrebtn'>Create</button>
                            </div>
                        </div>
                    </div>
                </>
            }
            {
                page == 11 &&
                <>
                    <div className="modalBackground">
                        <div className="modalContainerswww">
                            <div >
                                <div>
                                    <img src={pic31} className="divrightimg"></img>
                                </div>
                                <div className="divfontgmails">
                                    <span ><b>Teaching: Weekly Planning </b></span>
                                    <span >by Emma Trentman, Associate Pr...</span>
                                </div>
                            </div>
                            <div className="divanotherdivtext">
                                <span>Whether it's shipping a product
                                    or running through iterations of
                                    a project plan, this agile board template
                                    will help you get things done.</span>
                            </div>
                            <hr style={{ width: "250px", border: '1px solid darkgray', marginTop: "0.5rem" }} />
                            <label className='lablinputtext' for="myInput">Board Title</label>
                            <input id="myInput" type="text" placeholder="Teaching: Weekly Planning  " />
                            <label className='lablinputtext' for="myInput">Visibilty</label>
                            <div class="Workspacess">
                                <select className='slecoptondiv'>
                                    <option value="0">Workspace</option>
                                    <option value="1">Private</option>
                                    <option value="2">WorkSpace</option>
                                    <option value="2">Public</option>
                                </select>
                            </div>
                            <div>
                                <Form className='checkbivbox'>
                                    {['checkbox'].map((type) => (
                                        <div key={`Keep-${type}`} className="mb-3">
                                            <Form.Check
                                                type={type}
                                                id={`Keep-${type}`}
                                                label={`Keep ${type}`}
                                            />
                                        </div>
                                    ))}
                                </Form>
                            </div>
                            <div className="divanotherdivtextify">
                                <span >Activity and members will not be copied to the new board.</span>
                            </div>

                            <div className='btncre2btn'>
                                <button className='btncrebtn'>Create</button>
                            </div>
                        </div>
                    </div>
                </>
            }

        </div>
    );
}

export default Accordian;